import { Link, usePage } from "@inertiajs/react"
import { Join } from "./Common/Join"

export default function Footer() {
    const { year, ziggy } = usePage().props

    const origin = (ziggy?.url ?? "").replace(/\/$/, "")

    const sellerLinks = [
        { label: "Sell Guns Online", href: `${origin}/sell-my-gun` },
        { label: "Gun Consignment", href: `${origin}/gun-consignment` },
        {
            label: "Sell a Gun Collection",
            href: `${origin}/sell-gun-collection`,
        },
        { label: "Sell Inherited Guns", href: `${origin}/sell-inherited-guns` },
        { label: "Sell NFA Firearms", href: `${origin}/sell-nfa-firearms` },
        {
            label: "Sell Accessories & Ammo",
            href: `${origin}/sell-gun-accessories-and-ammo`,
        },
        {
            label: "Estate Firearms Services",
            href: `${origin}/estate-firearms-services`,
        },
    ]

    const siteLinks = [
        { label: "Auctions", href: `${origin}/auctions` },
        { label: "Brands", href: `${origin}/brands` },
        { label: "Categories", href: `${origin}/categories` },
        { label: "About Us", href: `${origin}/about-us` },
    ]

    return (
        <footer className="bg-dark-gray text-neutral-50 pb-6 lg:pb-[60px] pt-[117px]">
            <div className="container px-5 mx-auto 2xl:px-0">
                <div className="justify-between md:flex md:flex-col desktop:flex-row desktop:items-start desktop:gap-x-12">
                    <div className="flex flex-col items-center desktop:shrink-0">
                        <div className="flex justify-center">
                            <img
                                src="/images/logo-footer.webp"
                                className="inline-block h-[144px] w-auto"
                                width={235}
                                height={233}
                                alt="FirearmLand Logo Symbol"
                                loading="lazy"
                            />
                        </div>
                        <div className="mt-6">
                            <p className="text-sm text-center">
                                © Copyright {year} FirearmLand
                            </p>
                        </div>
                    </div>

                    <nav
                        aria-label="Site"
                        className="flex justify-center mt-10 desktop:mt-0 desktop:shrink-0"
                    >
                        <ul className="flex flex-col items-center gap-5 min-[721px]:grid min-[721px]:grid-flow-col min-[721px]:grid-rows-7 min-[721px]:gap-x-12 min-[721px]:content-start min-[721px]:items-start min-[721px]:justify-items-start min-[721px]:whitespace-nowrap">
                            {[...sellerLinks, ...siteLinks].map(
                                ({ label, href }) => (
                                    <li key={href}>
                                        <Link prefetch href={href}>
                                            {label}
                                        </Link>
                                    </li>
                                )
                            )}
                            <li>
                                <a href="mailto:sales@firearmland.com">
                                    Contact Us
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <div className="hidden mt-10 text-center lg:block desktop:mt-0 desktop:min-w-0 desktop:text-left">
                        <p className="mb-6 text-xl">Lock 'n Load Your Inbox</p>
                        <p>
                            Rare finds, VIP giveaways, and electrifying video
                            content. <br />
                            All delivered weekly directly to your inbox, FOR
                            FREE.
                        </p>

                        <div className="flex justify-center mt-8">
                            <Join w="490px" />
                        </div>

                        <p className="mt-4 text-sm">
                            Your adventure starts now
                        </p>
                    </div>
                </div>

                <div className="flex flex-col items-center justify-center gap-3 mt-8 text-center sm:flex-row sm:gap-4 desktop:justify-end">
                    <Link prefetch href="/privacy">
                        Privacy Policy
                    </Link>
                    <div className="hidden w-[1px] h-4 bg-gray-100 sm:block"></div>
                    <Link prefetch href="/terms">
                        Terms and Conditions
                    </Link>
                    <div className="hidden w-[1px] h-4 bg-gray-100 sm:block"></div>
                    {/* Persistent, site-wide CPRA/CCPA opt-out link. */}
                    <Link prefetch href="/privacy-choices">
                        Your Privacy Choices
                    </Link>
                </div>
            </div>
        </footer>
    )
}
